import { NotificationDesktop } from '@openeducation/oe-it-shared-types';
import { Asset } from 'expo-asset';
import { useEffect } from 'react';

export const useDesktopNotification = () => {
  useEffect(() => {
    if ('Notification' in window) {
      Notification.requestPermission();
    }
  }, []);

  const audioFile = Asset.fromModule(
    require('../assets/audio/notification.mp3')
  );
  const joinIconFile = Asset.fromModule(
    require('../assets/icons/join_button.png')
  );
  const closeIconFile = Asset.fromModule(
    require('../assets/icons/close_button.png')
  );

  const audio = new Audio(audioFile.uri);

  const showNotification = (notification: NotificationDesktop) => {
    const { icon, title, onClick, ...options } = notification;
    const handleClick = () => {
      window.focus();
      if (onClick) {
        onClick();
      }
    };

    const icons = {
      join: joinIconFile.uri,
      close: closeIconFile.uri,
    };

    const desktopNotification = new Notification(title, {
      ...options,
      icon: icon ? icons[icon] : '',
    });

    desktopNotification.onclick = (event) => {
      event.preventDefault();
      handleClick();
    };
    audio.play();

    return notification;
  };

  return {
    showNotification,
  };
};
